'use client';

import React, { useEffect, useRef } from 'react';


export default function CtaSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const section = sectionRef?.current;
    if (!section) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.reveal-up').forEach((el, i) => {
              setTimeout(() => el.classList.add('visible'), i * 100);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    observer?.observe(section);
    return () => observer?.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      id="assembly"
      className="relative py-24 lg:py-36 overflow-hidden"
      style={{
        background: `
          radial-gradient(ellipse 70% 60% at 50% 80%, rgba(212,80,10,0.18) 0%, transparent 65%),
          radial-gradient(ellipse 40% 40% at 80% 20%, rgba(232,148,58,0.07) 0%, transparent 60%),
          #0D0D10
        `,
      }}
    >
      {/* Grid lines decoration */}
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.04]"
        style={{
          backgroundImage: `
            linear-gradient(rgba(232,224,213,1) 1px, transparent 1px),
            linear-gradient(90deg, rgba(232,224,213,1) 1px, transparent 1px)
          `,
          backgroundSize: '80px 80px',
        }}
      />
      <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-14 text-center">

        <h2 className="reveal-up delay-1 font-sans font-900 text-[clamp(2.5rem,7vw,5.5rem)] leading-none tracking-tight text-bone uppercase mb-6">
          While Others Plan,<br />
          <span
            style={{
              color: '#BC3B4A',
            }}
          >
            We Deliver.
          </span>
        </h2>

        <p className="reveal-up delay-2 font-sans text-[1rem] text-bone-dim max-w-2xl mx-auto leading-relaxed mb-12">
Contact us on how we can assist in delivering your project, any where in the world
        </p>

      </div>
    </section>
  );
}